module.exports = __webpack_public_path__ + "img/f5189d6b90_6d9cd4dd71.d18ae246.webp";